import InboxOutlined from '@mui/icons-material/InboxOutlined';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

type Props = { title: string; hint?: string; action?: ReactNode; icon?: ReactNode };

export function EmptyState({ title, hint, action, icon }: Props) {
  return (
    <Paper variant="outlined" sx={{ px: 3, py: { xs: 5, md: 7 }, textAlign: 'center' }}>
      <Box
        aria-hidden
        sx={{ width: 48, height: 48, mx: 'auto', mb: 2, borderRadius: '50%', display: 'grid', placeItems: 'center', bgcolor: 'surface.sunken', color: 'text.secondary' }}
      >
        {icon ?? <InboxOutlined />}
      </Box>
      <Typography variant="h3" component="p">{title}</Typography>
      {hint ? (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.75, maxWidth: 420, mx: 'auto' }}>
          {hint}
        </Typography>
      ) : null}
      {action ? <Box sx={{ mt: 2.5 }}>{action}</Box> : null}
    </Paper>
  );
}
